export enum COOPERATION_PARTNER_IDS {
  EFFZEHSTROM = 'FC1',
  HAIESTROM = 'KEC1',
  NETCOLOGNE = 'NC100'
}
